module.exports = __webpack_public_path__ + "img/9788954437332.2e73abe8.jpg";